<script setup lang="ts">
const { t } = useI18n()

// Seo
useSeoMeta({
    titleTemplate: () => `%s - ${t('title')}`,
    title: () => t('dataProtection.title')
})
</script>

<template>
    <PageMainContainer>
        <DataProtection />
    </PageMainContainer>
</template>
